import { useState } from 'react';

export default () => {
  const [globalStates, setState] = useState({
    currentApp: null,
    isDraggable: false,
    isResizable: false,
    allowOverlap: false,
  });

  const setGlobalStates = (key: string, value: any): void => {
    setState({
      ...globalStates,
      [key]: value
    })
  }
  return { globalStates, setGlobalStates };
};